import {useEffect, useState} from "react";

import {Badge} from "@/components/ui/badge";
import {useActiveShift} from "@/src/modules/officer/hooks";
import {cn} from "@/lib/utils";

import {getActiveShiftBreakChipDisplay} from "../lib/active-shift-break-display";
import {getShiftEndDisplay} from "../lib/shift-end-display";

function useShiftEndTick(tickMs: number) {
  const [, setTick] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => setTick((n) => n + 1), tickMs);
    return () => window.clearInterval(id);
  }, [tickMs]);
}

const SHIFT_CHIP_CLASS = "shrink-0 px-2 py-0.5 text-xs font-medium leading-snug";

export function DispatchDeskShiftChip() {
  const {shift, isPending} = useActiveShift();

  const endIso = shift?.extended_end_datetime ?? shift?.to_datetime;
  const shiftEndDisplay = endIso ? getShiftEndDisplay(endIso) : null;
  const breakDisplay = shift ? getActiveShiftBreakChipDisplay(shift) : null;

  const tickMs = Math.min(
    shiftEndDisplay?.tickMs ?? 60_000,
    breakDisplay?.tickMs ?? 60_000,
  );
  useShiftEndTick(tickMs);

  if (isPending) return null;

  if (!shiftEndDisplay) {
    return (
      <Badge variant="secondary" className={SHIFT_CHIP_CLASS}>
        No active shift
      </Badge>
    );
  }

  return (
    <div className="flex flex-wrap items-center justify-end gap-2">
      {breakDisplay ? (
        <Badge
          variant={breakDisplay.variant}
          className={cn(SHIFT_CHIP_CLASS, "max-w-[14rem] truncate")}
        >
          {breakDisplay.label}
        </Badge>
      ) : null}
      <Badge
        variant={shiftEndDisplay.variant}
        className={cn(SHIFT_CHIP_CLASS, "max-w-[15rem] truncate")}
      >
        {shiftEndDisplay.text}
      </Badge>
    </div>
  );
}
